
const state = {
  isShow: false,
  dataSetting: {},
  defaultOption: false,
  editSettingAbsenceComplete: false
}
const getters = {
  isShow (state) {
    return state.isShow
  },
  dataSetting (state) {
    return state.dataSetting
  },
  dataDefaultOption(state) {
    return state.defaultOption
  },
  editSettingAbsenceComplete (state) {
    return state.editSettingAbsenceComplete
  }
}

const mutations = {
  OPEN_POPUP (state, dataPopup) {
    state.isShow = true
    state.dataSetting = dataPopup
  },
  CLOSE_POPUP (state) {
    state.isShow = false
  },
  EDIT_COMPLETE(state) {
    state.editSettingAbsenceComplete = !state.editSettingAbsenceComplete
  },
  DEFAULT_OPTION(state, data) {
    state.defaultOption = data
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
